export const localizeBilledUpon = (t, value)=>{
    switch(value){
        case 'ongoing':
            return t.servicesBilledUpon.ongoing();
        case 'oneTimeManual':
            return t.servicesBilledUpon.oneTimeManual();
        case 'approval':
            return t.servicesBilledUpon.approval();
        case 'repeatableManual':
            return t.servicesBilledUpon.repeatableManual();
        case 'oneTimeDelivery':
            return t.servicesBilledUpon.oneTimeDelivery();
        case 'oneTimeInStages':
            return t.servicesBilledUpon.oneTimeInStages();
        case 'onDemand':
            return t.servicesBilledUpon.onDemand();
        case 'inStagesManual':
            return t.servicesBilledUpon.inStagesManual();
        case 'inStagesPartlyAutomatic':
            return t.servicesBilledUpon.inStagesPartlyAutomatic();
        case 'inStagesAutomatic':
            return t.servicesBilledUpon.inStagesAutomatic();
        default:
            return value;
    }
};
export const localizeBillingOccurrence = (t, value)=>{
    switch(value){
        case 'onDemand':
            return t.servicesBillingOccurrence.onDemand();
        case 'oneTime':
            return t.servicesBillingOccurrence.oneTime();
        case 'inStages':
            return t.servicesBillingOccurrence.inStages();
        case 'weekly':
            return t.servicesBillingOccurrence.weekly();
        case 'biweekly':
            return t.servicesBillingOccurrence.biweekly();
        case 'monthly':
            return t.servicesBillingOccurrence.monthly();
        case 'quarterly':
            return t.servicesBillingOccurrence.quarterly();
        case 'yearly':
            return t.servicesBillingOccurrence.yearly();
        default:
            return value;
    }
};
export const localizeBillingTrigger = (t, value)=>{
    switch(value){
        case 'manual':
            return t.servicesBillingTrigger.manual();
        case 'automatic':
            return t.servicesBillingTrigger.automatic();
        case 'partlyAutomatic':
            return t.servicesBillingTrigger.partlyAutomatic();
        default:
            return value;
    }
};
export const localizeRecurrence = (t, value)=>{
    switch(value){
        case 'weekly':
            return t.servicesRecurrence.weekly();
        case 'biweekly':
            return t.servicesRecurrence.biweekly();
        case 'monthly':
            return t.servicesRecurrence.monthly();
        case 'quarterly':
            return t.servicesRecurrence.quarterly();
        case 'yearly':
            return t.servicesRecurrence.yearly();
        default:
            return value;
    }
};
export const localizePricingType = (t, value)=>{
    switch(value){
        case 'fixed':
            return t.servicesPricingType.fixed();
        case 'variable':
            return t.servicesPricingType.variable();
        case 'range':
            return t.servicesPricingType.range();
        case 'hourly':
            return t.servicesPricingType.hourly();
        case 'unitBased':
            return t.servicesPricingType.unitBased();
        default:
            return value;
    }
};
export const localizeDiscountType = (t, value)=>{
    switch(value){
        case 'none':
            return t.servicesDiscountType.none();
        case 'value':
            return t.servicesDiscountType.value();
        case 'percent':
            return t.servicesDiscountType.percent();
        default:
            return value;
    }
};
export const localizeStartOnType = (t, value)=>{
    switch(value){
        case 'yearly':
            return t.servicesStartOnType.yearly();
        case 'yearlyEffectiveDate':
            return t.servicesStartOnType.yearlyEffectiveDate();
        default:
            return value;
    }
};
